import { render, staticRenderFns } from "./ClassInformation.vue?vue&type=template&id=74c286e2&scoped=true"
import script from "./ClassInformation.vue?vue&type=script&lang=js"
export * from "./ClassInformation.vue?vue&type=script&lang=js"
import style0 from "./ClassInformation.vue?vue&type=style&index=0&id=74c286e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c286e2",
  null
  
)

export default component.exports